import React from "react";
import { InterfaceMode } from "./GenericComponent";

export class ToolbarComponent extends React.Component {
    constructor(props) {
        super(props);

        this.logger = window.BaseLogger;

        this.state = {};
    }

    render() {
        var self = this;
        return (
            <div className="toolbar">
                {this.props.mode == InterfaceMode.List && (
                    // List View
                    <div>
                        <button
                            className="btn btn-primary"
                            disabled={this.props.enableNew == false}
                            onClick={this.props.onNewClick}
                        >
                            <span className="glyphicon glyphicon-plus" />
                            <span className="d-none d-sm-block"> New</span>
                        </button>
                    </div>
                )}

                {this.props.mode == InterfaceMode.Display && (
                    // Item Display
                    <div>
                        <button className="btn btn-primary" onClick={this.props.onListClick}>
                            <span className="glyphicon glyphicon-th-list" />
                            <span className="d-none d-sm-block"> List</span>
                        </button>
                        <button
                            className="btn btn-primary"
                            disabled={this.props.enableNew == false}
                            onClick={this.props.onNewClick}
                        >
                            <span className="glyphicon glyphicon-plus" />
                            <span className="d-none d-sm-block"> New</span>
                        </button>
                        <button
                            className="btn btn-primary"
                            disabled={this.props.enableEdit == false}
                            onClick={this.props.onEditClick}
                        >
                            <span className="glyphicon glyphicon-pencil" />
                            <span className="d-none d-sm-block"> Edit</span>
                        </button>
                        <button className="btn btn-primary" onClick={this.props.onPdfClick}>
                            <span className="glyphicon glyphicon-file" />
                            <span className="d-none d-sm-block"> PDF</span>
                        </button>
                        <button
                            className="btn btn-primary"
                            disabled={this.props.enableClone == false}
                            onClick={this.props.onCloneClick}
                        >
                            <span className="glyphicon glyphicon-duplicate" />
                            <span className="d-none d-sm-block"> Clone</span>
                        </button>
                        <button
                            className="btn btn-primary"
                            disabled={this.props.enableDelete == false}
                            onClick={this.props.onDeleteClick}
                        >
                            <span className="glyphicon glyphicon-trash" />
                            <span className="d-none d-sm-block"> Delete</span>
                        </button>
                    </div>
                )}

                {this.props.mode == InterfaceMode.Edit && (
                    // Item Edit
                    <div>
                        <button className="btn btn-primary" onClick={this.props.onListClick}>
                            <span className="glyphicon glyphicon-th-list" />
                            <span className="d-none d-sm-block"> List</span>
                        </button>
                        <button className="btn btn-primary" onClick={this.props.onDisplayClick}>
                            <span className="glyphicon glyphicon-eye-open" />
                            <span className="d-none d-sm-block"> Display</span>
                        </button>
                    </div>
                )}

                {this.props.mode == InterfaceMode.New && (
                    // New Item
                    <div>
                        <button className="btn btn-primary" onClick={this.props.onListClick}>
                            <span className="glyphicon glyphicon-th-list" />
                            <span className="d-none d-sm-block"> List</span>
                        </button>
                    </div>
                )}
            </div>
        );
    }
}
